export default "__VITE_ASSET__DGrXvoxo__"